


















import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Item from '../models/Item';
    @Component
export default class ListadoComponent extends Vue {
        private item ? : Item = new Item({});

        private breadcrumbs: any = [];

        private menu : any;

        private indexes : Array<any> = [];

        mounted() {
          const json = window.localStorage.getItem('menu') || '';
          if (!json) return;
          this.menu = JSON.parse(json);

          this.fetch();
        }

        fetch() {
          const clone = this.breadcrumbs;
          this.breadcrumbs = [];
          const params = this.$router.currentRoute.params;
          const indexes = params.pathMatch.split('/');
          this.indexes = indexes;
          const selectedItem = this.getItem(this.menu[indexes[0]], indexes, 1);

          if (selectedItem.type === 'dir') {
            this.item = new Item(selectedItem);
            console.log(this.item);
          } else {
            this.breadcrumbs = clone;

            this.siguiente(-1, selectedItem);
          }
          this.breadcrumbs[0].text = `TOMO ${this.romano(+indexes[0] + 1)}`;

          // console.log(this.item);
        }

        romano(numero: number) {
          switch (numero) {
            case 1: return 'I';
            case 2: return 'II';
            case 3: return 'III';
            case 4: return 'IV';
            case 5: return 'V';
            case 6: return 'VI';
            case 7: return 'VII';
            case 8: return 'VIII';
            default: return '';
          }
        }

        getItem(menu : any, indexes : any, i : number) : any {
          if (!menu.data) return menu;
          this.breadcrumbs.push({
            text: menu.filename,
            to: `/listado/${indexes.slice(0, i).join('/')}`,
          });
          if (menu.data.length && i < indexes.length) {
            const item = menu.data[indexes[i]];
            return this.getItem(item, indexes, i + 1);
          }
          return menu;
        }

        siguiente(index: number, child : Item, ext : string = '') {
          if (child.xlsx && !ext) return;
          if (child.docx && !ext) return;
          if ((!child.docx && !child.xlsx) && ext === 'pdf') return;


          const params = [
            'height=800',
            'width=600',
            'fullscreen=yes', // only works in IE, but here for completeness
          ].join(',');

          if (child.type === 'dir') {
            // child.prev = this.item;
            window.localStorage.setItem('item', JSON.stringify(child));
            this.indexes.push(index);
            this.$router.push(`/listado/${this.indexes.join('/')}`);
          } else if (ext) {
            if (ext === 'pdf') {
              window.open(child.route.replace('.xlsx', '.pdf').replace('.docx', '.pdf'), '_blank', params);
            } else {
              window.open(child.route.replace('.pdf', `.${ext}`), '_self');
            }
          } else {
            window.open(child.route.replace('.xlsx', '.pdf').replace('.docx', '.pdf'), '_blank', params);
          }
        }

        @Watch('$route')
        onRouteChange(val: string, oldVal: string) {
          this.fetch();
        }
}
